module.exports = __webpack_public_path__ + "static/media/bg_pridetalks.f7dec56b.svg";